import { render, staticRenderFns } from "./SearchResultTemp.vue?vue&type=template&id=15a0f1e7&scoped=true&"
import script from "./SearchResultTemp.vue?vue&type=script&lang=js&"
export * from "./SearchResultTemp.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultTemp.vue?vue&type=style&index=0&id=15a0f1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0f1e7",
  null
  
)

export default component.exports